import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { useEffect, useState } from "react";

export const PreviewPdfModal = ({
  url,
  initialPage,
  onClose,
}: {
  url: string;
  initialPage?: number;
  onClose: () => void;
}) => {
  const [blobUrl, setBlobUrl] = useState<string>();

  useEffect(() => {
    const fetchBlob = async () => {
      const res = await fetch(url);
      const buf = await res.arrayBuffer();
      const blob = new Blob([buf], { type: "application/pdf" });
      setBlobUrl(URL.createObjectURL(blob));
    };

    fetchBlob();
  }, [url]);

  const iframeSrc = blobUrl
    ? initialPage && initialPage > 0
      ? `${blobUrl}#page=${Math.floor(initialPage)}`
      : blobUrl
    : undefined;

  return (
    <Modal isOpen={true} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent height="95%" width="full" pt="10">
        <ModalCloseButton />
        <ModalBody height="full" width="full">
          <iframe src={iframeSrc} title="PDF preview" style={{ width: "100%", height: "100%", border: 0 }} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
